export default {
  nav: {
    home: 'Home',
    assessment: 'Assessment',
    faq: 'FAQ',
    contact: 'Contact',
    login: 'Login',
    personalCenter: 'Profile'
  },
  hero: {
    title1: 'Net Ban',
    title2: 'Chinese Proficiency Quick Test',
    sub: '',
    start: 'Start Test',
    tagWrite: 'Writing',
    tagSpeak: 'Speaking',
    tagRead: 'Reading',
    aiBadge: 'AI Chinese Assessment'
  },
  whatIs: {
    title: 'What is CPQT?',
    p1: 'The Chinese Proficiency Rapid Assessment Platform integrates advanced technologies such as artificial intelligence, natural language processing, and intelligent speech recognition to deliver a fast, objective, and accurate evaluation of learners authentic language application abilities.',
    p2: 'Moving beyond traditional testing models, the platform leverages intelligent scoring, multi-dimensional analysis, and data-driven feedback to provide reliable assessment results for schools, ',
    p3: 'training institutions, and individual learners, thereby offering a scientific basis for teaching optimization and learning enhancement.',
    viewMore: 'View More'
  },
  whoWill: {
    title: 'Who will take the CPQT test?',
    subtitle: 'It satisfies the requirements for Chinese proficiency evaluation across diverse learning stages and application contexts.',
    itemsHeader: [
      'International students',
      'University students',
      'Chinese language learners',
      'Schools and educational institutions',
      'Enterprises and public institutions'
    ],
    items: [
      'Provide a reference for Chinese proficiency assessment for international students coming to China.',
      'Assist in course learning, periodic assessments, and learning diagnosis.',
      'Enable learners to quickly understand their own Chinese proficiency and prepare effectively for study and communication.',
      'Offer a comprehensive overview of students\' learning progress and provide data‑driven support for teaching.',
      'Facilitate employee Chinese proficiency assessments to meet the needs of international talent cultivation.'
    ]
  },
  philosophy: {
    title: 'Our Philosophy',
    sub: 'Making assessment smarter and learning more efficient',
    btn: 'Start Test'
  },
  howTo: {
    title: 'How to complete the tests?',
    desc1: 'Fully online, it only takes about 30 minutes to complete a quick Chinese proficiency assessment.',
    desc2: '',
    scenario: 'Scenario',
    scenarioA: 'Log in to the platform',
    scenarioB: 'Complete the assessment',
    scenarioC: 'View the report',
    descA: 'Register an account and enter the assessment system',
    descB: 'Follow the prompts to complete the listening, speaking, and comprehensive ability assessment',
    descC: 'The system automatically generates an assessment report, providing a comprehensive analysis of your learning progress',
    minutes: 'minutes'
  },
  faqSection: {
    title: 'Frequently Asked Questions',
    q1: 'What unique advantages does NBCFA possess?',
    a1: 'NBCFA uses AI adaptive assessment technology with short assessment time, accurate results, multi-dimensional ability analysis reports, and personalized learning suggestions.',
    q2: 'How much time does a NBCFA test take?',
    a2: 'The standard assessment takes about 30 minutes, including three scenario modules: listening comprehension & response, academic interaction, and academic reading & writing.',
    q3: 'What devices are required?',
    a3: 'You only need a computer and a headset to complete the entire assessment online, no additional software installation required.',
    viewMore: 'View More'
  },
  footer: {
    quickLinks: 'Quick Links',
    home: 'Home',
    aboutCepa: 'About CPQT',
    startTest: 'Start test',
    support: 'Support',
    contact: 'Contact',
    servicePolicy: 'Service Policy',
    faq: 'FAQ',
    copyright: 'A NETCLASS Company (Nasdaq: NTCL) Copyright © 2026 NBCFA. All rights reserved.'
  },
  login: {
    welcome: 'Welcome',
    subtitle1: 'Net Ban',
    subtitle2: ' Chinese Fast Assessment Center',
    loginTitle: 'Login',
    registerTitle: 'Register',
    username: 'Username',
    usernamePh: 'Enter username',
    email: 'Email',
    emailPh: 'Enter email',
    password: 'Password',
    passwordPh: 'Enter password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPh: 'Enter password again',
    submit: 'Login',
    submitReg: 'Register',
    loading: 'Please wait...',
    noAccount: 'No account yet?',
    hasAccount: 'Already have an account?',
    goRegister: 'Register now',
    goLogin: 'Go to login',
    pwdMismatch: 'Passwords do not match',
    pwdTooShort: 'Password must be at least 6 characters',
    usernameTooShort: 'Username must be at least 3 characters',
    usernameInvalid: 'Username can only contain letters, numbers and underscores',
    emailInvalid: 'Please enter a valid email address',
    required: 'This field is required',
    networkError: 'Network error, please try again later',
    registerSuccess: 'Registration successful, please login'
  },
  user: {
    personalData: 'Personal Data',
    myTests: 'My Tests',
    profile: 'Profile',
    logout: 'Log out',
    currentLevel: 'Current Level',
    totalTests: 'Total Tests',
    bestLevel: 'Best Level',
    testsHistory: 'Tests History',
    testDate: 'Test Date',
    testId: 'Test ID',
    score: 'Score',
    grade: 'Grade',
    duration: 'Duration',
    status: 'Status',
    report: 'Report',
    action: 'Action',
    completed: 'Completed',
    inProgress: 'In Progress',
    aborted: 'Early Termination',
    pending: 'Pending',
    viewReport: 'View Report',
    noRecords: 'No test records',
    minutes: 'minutes',
    username: 'Username',
    email: 'Email',
    familyName: 'Family Name',
    familyNamePh: 'Enter Family Name',
    givenName: 'Given Name',
    givenNamePh: 'Enter Given Name',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    newPasswordHint: 'Must be at least 6 characters with a mix of letters and numbers',
    confirmPassword: 'Confirm Password',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    birthday: 'Birthday',
    country: 'Country/Region (Optional)',
    countryPh: 'Please choose Country',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed'
  },
  assessment: {
    notice: 'Assessment Notice',
    noticeDesc: 'Hello, please estimate the time for this assessment and reserve enough time. This assessment does not support mid-way exit. If you exit, the results will not be recorded and you will need to retake the assessment.',
    phase1: 'Listening (5 min)',
    phase2: 'Oral (5 min)',
    phase3: 'Reading (5 min)',
    phase4: 'Writing (5 min)',
    startBtn: 'Start Assessment',
    inProgress: 'Assessment in progress',
    holdToSpeak: 'Hold to speak',
    waitForPlay: 'Please wait for audio playback',
    reRecord: 'Re-record',
    confirmSend: 'Send',
    resultTitle: 'Assessment Results',
    close: 'Close',
    exitTitle: 'Confirm Exit?',
    exitDesc: 'Exiting will end the assessment immediately and generate a final score. This action cannot be undone.',
    continueExam: 'Continue',
    confirmExit: 'Exit',
    roundNum: 'Q{n}',
    toastStartFailed: 'Failed to start assessment: ',
    toastPlayFailed: 'Failed to play recording',
    toastNoRecording: 'No recording to send',
    toastSubmitFailed: 'Failed to submit answer: ',
    toastNextFailed: 'Failed to get next question, please retry',
    toastResultFailed: 'Failed to get results: ',
    inputPh: 'Enter your answer',
    finished: 'Assessment completed, thank you!',
    finishedMsg: 'Assessment completed! Thank you for your participation. We will generate your report shortly.',
    viewResult: 'View Result',
    backHome: 'Back to Home',
    exitConfirm: 'The assessment is in progress. If you exit now, your score will be calculated based on completed questions, and unanswered questions will be marked as 0. Are you sure you want to end the assessment?',
    intro1: 'Part 1: Listening comprehension. You will hear a scenario and a question, please respond with your voice. Let\'s begin the listening assessment.',
    intro2: 'Congratulations on completing Part 1. Now let\'s move to Part 2: Oral expression. You will see a text, please read it aloud.',
    intro3: 'Congratulations on completing Part 2. Now let\'s move to Part 3: Reading comprehension. Please answer using voice.',
    intro4: 'Congratulations on completing Part 3. Now let\'s move to Part 4: Writing. Please use your keyboard to answer.',
    sideTitle: 'Chinese Assessment',
    q1_1: 'Please listen to the following audio and retell the content',
    q1_2: 'Please listen to the following audio and answer the question',
    q2_1: 'Please answer: Where is your hometown?',
    q2_2: 'Please answer: What does the author express in the following passage?',
    q2_3: 'Please answer: Where is your hometown?',
    q3_1: 'Please answer: Where is your hometown?',
    q3_2: 'What is the pinyin of the character "单"?',
    q3_3: 'Please write a paragraph describing the food of your hometown, around 400 characters'
  },
  report: {
    congrats: 'Congratulations on completing the Chinese Proficiency Assessment!',
    subtitle: 'Here is your assessment report',
    abortedTitle: 'Assessment Terminated',
    abortedSubtitle: 'You exited the assessment early. Below are the results for completed questions.',
    download: 'Download Report',
    certTitle: 'Chinese Proficiency Test',
    levelLabel: ' (Level 6) Score Report',
    name: 'Name:',
    gender: 'Gender:',
    nationality: 'Nationality:',
    examDate: 'Exam Date:',
    year: 'Y',
    month: 'M',
    day: 'D',
    examNo: 'No.:',
    ticketNo: 'Admission Ticket:',
    fullScore: 'Full Score',
    yourScore: 'Your Score',
    listening: 'Listening',
    oral: 'Oral',
    reading: 'Reading',
    writing: 'Writing',
    totalScore: 'Total',
    gradeLabel: 'Overall Grade',
    radarGrammar: 'Grammar',
    radarVocab: 'Vocabulary',
    radarSpeaking: 'Speaking',
    director: 'Director:',
    org: 'Center for Language Education and Cooperation',
    location: 'Shanghai, China',
    backHome: 'Back to Home'
  },
  faq: {
    title: 'Frequently Asked Questions',
    list: [
      { q: 'What unique advantages does NBCFA possess?', a: 'NBCFA uses AI adaptive assessment technology, providing fast and accurate results, multi-dimensional analysis reports, and personalized learning suggestions.' },
      { q: 'How much time does a NBCFA test take?', a: 'The standard assessment takes about 30 minutes, including four modules: Listening Comprehension, Oral Expression, Reading Comprehension, and Writing Expression.' },
      { q: 'What devices are required?', a: 'Only a computer and a headset are needed to complete the entire assessment online, no additional software required.' },
      { q: 'What is the scoring standard of NBCFA?', a: 'Scoring is based on AI multi-dimensional analysis, including pronunciation accuracy, fluency, content completeness, and language expression, generating a comprehensive proficiency report.' },
      { q: 'How soon can I view the results?', a: 'The result report is generated immediately after the assessment. You can view detailed analysis and learning suggestions in your personal center.' },
      { q: 'Can I take the test multiple times?', a: 'Yes, multiple assessments are supported. The system records each result to track learning progress and improvement.' }
    ]
  }
}
